"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TauntAbilityHandler = exports.TauntActorAbilityFactory = exports.TauntAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const Taunted_1 = require("../../core/effects/core/Taunted");
class TauntAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Taunt;
        this.__typeName = "Taunt";
    }
}
exports.TauntAbilityArgs = TauntAbilityArgs;
let TauntActorAbilityFactory = class TauntActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Taunt", "OneEnemies", 1);
    }
};
TauntActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Taunt")
], TauntActorAbilityFactory);
exports.TauntActorAbilityFactory = TauntActorAbilityFactory;
let TauntAbilityHandler = class TauntAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        container.applyAbilityAnimation({
            abilityKey: ability.args.__typeName,
            animatedId: ability.invokerId,
            fallback: "attacking",
            sequence,
            onAnimated: sequence => {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Turns(2),
                    effect: new Taunted_1.TauntedEffectArgs
                });
            }
        });
    }
};
TauntAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Taunt)
], TauntAbilityHandler);
exports.TauntAbilityHandler = TauntAbilityHandler;
